import "./checkbox.css"

interface CheckboxProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export const Checkbox = ({ checked, id, label, onChange } : CheckboxProps) => {
    return (
    <div className="checkbox-container">
        <input 
            className="checkbox-input" 
            id={id} 
            type="checkbox"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
        />
        <label htmlFor={id}>{label}</label>
    </div>
    );
}